pez.module('grayscale-image', function($, $el) {
    if(Modernizr && Modernizr.cssfilters) return;

    var isImage = $el.is('img');
    var src = isImage ? $el.attr('src') : $el.data().image;
    var imgObj = new Image();
    imgObj.src = src;
    $(imgObj).one('load', imageLoaded);

    function imageLoaded() {
        if(isImage) {
            var graySrc = grayify();
            $el.attr('data-src-gray', graySrc);
            $el.attr('data-src', $el.attr('src'));
            $el.attr('src', grayify());
            $el.closest('.company').hover(function() {
                $el.attr('src', $el.attr('data-src'));
            }, function() {
                $el.attr('src', $el.attr('data-src-gray'));
            });
        } else {
            var $grayEl = $el.clone();
            $grayEl.css('background-image', 'url(' + grayify() + ')');
            $grayEl.removeClass('color').addClass('greyscale');
            $el.after($grayEl);
        }
    }

    function grayify() {
        var canvas = document.createElement('canvas');
        var canvasContext = canvas.getContext('2d');

        var imgW = imgObj.width;
        var imgH = imgObj.height;
        canvas.width = imgW;
        canvas.height = imgH;

        canvasContext.drawImage(imgObj, 0, 0);
        var imgPixels = canvasContext.getImageData(0, 0, imgW, imgH);

        for(var y = 0; y < imgPixels.height; y++){
            for(var x = 0; x < imgPixels.width; x++){
                var i = (y * 4) * imgPixels.width + x * 4;
                var avg = (imgPixels.data[i] + imgPixels.data[i + 1] + imgPixels.data[i + 2]) / 3;
                imgPixels.data[i] = avg;
                imgPixels.data[i + 1] = avg;
                imgPixels.data[i + 2] = avg;
            }
        }
        canvasContext.putImageData(imgPixels, 0, 0, 0, 0, imgPixels.width, imgPixels.height);
        return canvas.toDataURL();
    }

    //if(Modernizr && !Modernizr.cssfilters) {

    //}
});
